export default {
  CREATE: `Créer un attribut`,
  DELETE_BUTTON: {
    TITLE: `Supprimer l'attribut`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cet attribut ?`,
    PRIMARY_ACTION: `Supprimer l'attribut`
  },
  LIST: {
    TITLE: `Liste des attributs`
  },
  SELF_ASSIGNABLE: `Auto-assignation`,
  DESCRIPTION: `Description`,
  LEVELS: `Niveau`,
  REMINDERS: `Rappels`,
  LEVEL_DESCRIPTION: `Du moins qualifié au plus qualifié (1 étant très peu qualifié et 10 étant très qualifié)`,
  TYPE: `Type`,
  RESTRICTION: `Restriction`,
  REQUIREMENT: `Exigence`,
  ALERT: `Alerte`,
  SKILL: `Qualification`,
  FORMED: `Formé`,
  CSV_EXPORT_NAME: `export_attributs_{{date}}`,
  DAYS: `Jours`,
  form: {
    CREATE: {
      TITLE: `Création d'attribut`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modification d'attribut`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Nom de l'attribut`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement le repérer.`,
      PLACEHOLDER: `Entrez un nom pour l'attribut`
    },
    DESCRIPTION: {
      LABEL: `Description de l'attribut`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Entrez une description pour l'attribut`
    },
    SELFASSIGN: {
      LABEL: `Assignable par l'utilisateur`,
      DESCRIPTION: `Permettra aux employés de s'auto-assigner cet attribut à partir de leur profil.`
    },
    HASEXPIRATIONDATE: {
      LABEL: `A une date d'expiration`,
      DESCRIPTION: `Permettra d'envoyer des rappels aux employés qui doivent renouveller leur attribut.`
    },
    REMINDERS: {
      LABEL: `Délai du rappel`,
      DESCRIPTION: ``,
      PLACEHOLDER: ``
    },
    HASCUSTOMMESSAGE: {
      LABEL: `Ajouter un message personnalisé`,
      DESCRIPTION: ``
    },
    CUSTOMMESSAGE: {
      LABEL: `Message personnalisé`,
      DESCRIPTION: `Ecrivez votre message dans le language correspondant (Anglais pour #en, Français pour #fr)`,
      PLACEHOLDER: ``
    },
    CODE: {
      LABEL: `Code d'importation`,
      DESCRIPTION: `Le code d'importation sert à pouvoir assigner des attributs à d'autres ressources avec les outils d'importation.`,
      PLACEHOLDER: `Entrez le code d'importation`
    },
    TYPE: {
      LABEL: `Type d'attribut`,
      DESCRIPTION: `Il existe trois types d’attributs, les restrictions qui empêchent d’être éligible à un quart de travail, les qualifications requises pour effectuer le quart et les exigences qui sont nécessaires pour être éligible.`
    },
    RANK: {
      LABEL: `Valeur du niveau`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Entrez une valeur pour le niveau`
    },
    LEVELNAME: {
      LABEL: `Nom`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Entrez un nom`
    },
    REQUIREACKNOWLEDGEMENT: {
      LABEL: `Exigence de confirmation`,
      DESCRIPTION: `Une fenêtre modale s'affichera à l'ouverture de session de l'employé et des notifications lui seront envoyées tous les jours jusqu'à qu'il confirme avoir pris connaissance des ses attributes arrivant à expiration.`
    },
    SENDCOPYTOCOMPANYEMAIL: {
      LABEL: `Envoyer une copie à l'adresse courriel de l'entreprise`,
      DESCRIPTION: `Le rappel sera également envoyé à l'adresse courriel de l'entreprise.`
    },
    NAME_REQUIRED: `Le nom de l'attribut est obligatoire.`,
    TYPE_REQUIRED: `Le type d'attribut est obligatoire.`,
    AT_LEAST_ONE_LEVEL_REQUIRED: `Il doit y avoir au moins un niveau.`,
    AT_LEAST_ONE_REMINDER_REQUIRED: `Il doit y avoir au moins un rappel.`,
    NAME_ALREADY_USED: `Le nom est déjà utilisé.`,
    LEVELS_UNIQUE: `Les niveaux de compétence doivent être uniques.`
  }
}
